<template>
  <div class="ei-long-figure-scroll-auto">
    <div class="scroll-bg" :style="{animationDuration:duration_bg+'s',width:bgWidth+'px'}">
      <img src="./_ei-long-figure-scroll/background.png" alt="">
    </div>
    <div class="scroll-content">
      <ul class="scroll-list" id="scroll-list" :style="{animationDuration:duration+'s',width:listWidth+'px'}">
        <li :class="{'scroll-item':true}" v-for="(item,index) in worksList" :key="index">
          <div>
            <img :src="item.imgUrl" alt="[图片]" @click="toWorksDetail(item.rowGuid)">
          </div>
          <h3 :style="{width:item.imgWidth}" class="worksNameContent" @click="toWorksDetail(item.rowGuid)">
            {{ item.worksName }}</h3>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

export default {
  name: 'EiLongFigureScrollForPerson',
  data () {
    return {
      duration: 0,
      listWidth: 0,
      taBenUrl: '',
      moreStyle: false,
      taBenAttaches: [],
      duration_text: 0,
      duration_bg: 0,
      bgWidth: 4167
    }

  },
  props: {
    speed: {
      type: Number,
      default: 150
    },
    worksList: {
      type: Array,
      required: true
    },
  },
  watch: {
    worksList: function (newVal, oldVal) {
      this.initKeyframes_Img()
    }
  },
  created () {
  },
  updated () {
    this.initKeyframes_Bg()
  },
  methods: {
    initKeyframes_Bg () {
      let startX = -this.bgWidth
      let endX = 1920
      this.duration_bg = (endX - startX) / this.speed
      let style = document.createElement('style')
      document.getElementsByTagName('head')[0].appendChild(style)
      style.appendChild(document.createTextNode(''))
      document.styleSheets[document.styleSheets.length - 1].insertRule(`
                   @keyframes scrollBg{
                0%{ transform: translate(${startX}px,0);}
                100%{transform: translate(${endX}px,0);}
            }
          `)
    },
    initKeyframes_Img () {
      let totalWidth = 0
      totalWidth = this.worksList.length * 330
      if (totalWidth === 0) return
      console.log(totalWidth)
      let startX = -totalWidth
      let endX = 1920
      this.listWidth = totalWidth
      this.duration = (endX - startX) / this.speed
      let style = document.createElement('style')
      document.getElementsByTagName('head')[0].appendChild(style)
      style.appendChild(document.createTextNode(''))
      document.styleSheets[document.styleSheets.length - 1].insertRule(`
            @keyframes scroll{
               0%{transform: translate(${startX}px,0);}
               100%{ transform: translate(${endX}px,0);}
            }
          `)
    },

    toWorksDetail (rowGuid) {
      this.$router.push({
        path: '/WorksDetail',
        query: { guid: rowGuid }
      })
    },
  }
}


</script>
<style scoped lang="scss">
.ei-long-figure-scroll-auto {
  position: relative;
  width: 100%;
  overflow: hidden;
  cursor: pointer;
}

.scroll-content {
  position: relative;
  width: 1907px;
  height: 520px;
  white-space: nowrap;
  overflow: hidden;
  /*  margin-top: 74px;*/

  .scroll-list {
    position: absolute;
    left: 0;
    height: 100%;
    width: 300%;
    animation: scroll 10s linear infinite;

    .scroll-item {
      float: right;
      width: 330px;
      overflow: hidden;

      h3 {
        text-align: center;
        font-size: 22px;
      }
    }


  }
}

.bottom-scroll-text {
  width: 1903px;
  overflow: hidden;
  height: 60px;
  position: relative;

  img {
    position: absolute;
  }

  img:nth-child(2) {
    position: absolute;
    right: 0;
    transform: scaleX(-1);
  }

  .scroll-text {
    position: absolute;
    font-size: 30px;
    white-space: nowrap;
    line-height: 60px;
    animation: scrollText linear infinite;
  }
}

.scroll-bg {
  position: absolute;
  width: 1903px;
  height: 480px;
  top: 0;
  left: 0;
  background-color: #fff;
  animation-name: scrollBg;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-play-state: running;
}

.ei-long-figure-scroll-auto:hover .scroll-list {
  animation-play-state: paused;
}

.ei-long-figure-scroll-auto:hover .scroll-text {
  animation-play-state: paused;
}

.ei-long-figure-scroll-auto:hover .scroll-bg {
  animation-play-state: paused;
}

.worksNameContent {
  font-weight: normal;
  background: linear-gradient(40deg, #2E8B57, #191970, #00BFFF, #8B0000, #000000);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: worksNameContentX 5s linear infinite;
}

@keyframes worksNameContentX {
  from {
    filter: hue-rotate(0deg);
  }
  to {
    filter: hue-rotate(360deg);
  }
}
</style>
